import MyAlgoConnect from './Stub_MAC';
export default MyAlgoConnect;
